import { useEffect, useRef, useState } from "react";
import { Col, Form, Row } from "react-bootstrap";
import { useTranslation } from 'react-i18next';

import { FieldArray, Formik } from "formik";

import _ from 'lodash';

import { HeaderRegister } from "../../../components/HeaderRegister";
import { ConfigImpositionModel } from "../../../models/configImposition.model"

import { ToastService } from "../../../services/toast.service";
import { DatasetDefault } from '../../../models/dataset.model';
import { RequestInputOutputParamsModel, RequestInputOutputParamsModelDefault} from '../../../models/requestInputOutputParams.model';
import { init } from "i18next";
import ConfigService from "../../../services/config.service";

import storageService from "../../../services/storage.service";


export const PickupImpositionConfig = () => {
  
  const [initialValues, setInitialValues] = useState({
    selectionTypeId: "0",
    listValues: []
  });



  const ListTypes  = [
    {
      id: 1,
      title: 'CONFIG.GROUP_GENERAL'
    },
    {
      id: 2,
      title: 'CONFIG.GROUP_PROFILE'
    },
    {
      id: 3,
      title: 'CONFIG.GROUP_BRANCH',
    },
    {
      id: 4,
      title: 'CONFIG.GROUP_BRANCH_ACTION',
    },
    {
      id: 5, 
      title: 'CONFIG.GROUP_BRANCH_ACTION_CASH_CHANGE_DELIVERY',
    }
  ]

  const [isLoading, setLoading] = useState(false);
  const { t } = useTranslation();
  const formRef = useRef();
  const [showNewModel, setShowNewModel] = useState(false);
  const [selectedList, setSelectedList] = useState([])
  
  const initialize = async () => {
    setLoading(true);
    // Init
    setLoading(false);
  };

  const user = storageService.getUser();

  useEffect(() => {
    initialize();
  }, []);

  const returnSubTitle = (label: string) => {
    if (label == '1')
      return t('CONFIG.GROUP_GENERAL');
    if (label == '2')
      return t('CONFIG.GROUP_PROFILE');
    if (label == '3')
      return t('CONFIG.GROUP_BRANCH');
    if (label == '4')
      return t('CONFIG.GROUP_BRANCH_ACTION');
    if (label == '5')
      return t('CONFIG.GROUP_BRANCH_ACTION_CASH_CHANGE_DELIVERY')

    return '';
  }

  const selectAll = (checked: boolean, list: ConfigImpositionModel[]) =>
  {
    let selected = [];
    if (checked)
    {
      list.map((l:ConfigImpositionModel) => {
        selected.push(l.id);    
      });
    }
    setSelectedList(selected);
  }

  const allSelected = (list: ConfigImpositionModel[]) => {
    return selectedList.length == list.length;
  }

  const submitFormik = () => {
    if (formRef && formRef.current) {
      let current: any = formRef.current;
      current.handleSubmit();
    }
  };

  const onSubmit = async (date) => {
    try {
      if (date.selectionTypeId == undefined || date.selectionTypeId == '') {
        ToastService.warn(t('CONFIG.ALERT_TYPE_NEEDED'), null);
        return;
      }

      let dataset = {
        dataset: 'imposition',
        filters: {
          type_code: [Number(date.selectionTypeId)],
          selected_values: selectedList
        },
        sort: {
          field: 'read_date',
          orientation: 'desc'
        }
      };

      let requestParams: RequestInputOutputParamsModel = { ...RequestInputOutputParamsModelDefault, datasets: [dataset] };

      date.Id = date.selectionTypeId;
      date.values = selectedList;
      const response: any = await ConfigService.SaveImpositionList(requestParams);
      if (response.success) {
        ToastService.success(t('CONFIG.DATA_UPDATED'));
      }
    } catch (error) {
      ToastService.error(t('ERROR_GENERIC'));
    }
  };

  return (
    <>
      <HeaderRegister
        title={`${t('CONFIG.IMPOSITION_TITLE')} | ${window.location.hash.includes("add") ? t("REGISTRATION") : t("EDITION")}`}
        path={"/Models"}
        submitForm={submitFormik}
        isLoading={isLoading || user.profile.profileName === "adm_reader" || user.profile.profileName === "sys_admin"}
        btnBack={false}
      />

      <Formik
        enableReinitialize={true}
        innerRef={formRef}
        initialValues={initialValues}
        onSubmit={(values) => {
          onSubmit(values);
        }}
      >
        {({
          handleSubmit,
          handleChange,
          handleBlur,
          values,
          touched,
          errors,
          setValues
        }) => (
          <Form noValidate onSubmit={handleSubmit}>
            <Row>
              <Col xs={12} xl={12}>
                <Row className="align-items-center">
                  <Col sm={12} md={6} lg={3} className="mb-4">
                    <Form.Group>
                      <Form.Floating>
                        <Form.Select
                          id='selectionTypeId'
                          name='selectionTypeId'
                          isInvalid={touched.selectionTypeId && !!errors.selectionTypeId}
                          disabled={isLoading}
                          onChange={(event) => {
                            let value = event.target.value;
                            if (value) {
                              ConfigService.GetConfigImpositionListByType(event.target.value).then((response: any) => {
                                setValues(prevValues => ({
                                  ...prevValues,
                                  selectionTypeId: value,
                                  listValues: response.result.datasets[0].data
                                }));
                                setSelectedList(response.result.datasets[0].data.map((l:ConfigImpositionModel) => l.checked ? l.id : 0).filter(x => x > 0));                                
                              });                                                            
                            } else {
                              setValues(prevValues => ({
                                ...prevValues,
                                selectionTypeId: value,
                                listValues: []
                              }));
                              setSelectedList([]);
                            }
                          }}
                          value={values.selectionTypeId}
                          aria-label={t("CONFIG.FILTER")}>
                          <option value=''>{t("CONFIG.FILTER")}</option>
                          {_.map(ListTypes, (l) => {
                            return <option key={l.id} value={l.id}>{t(l.title)}</option>
                          })}
                        </Form.Select>
                        <Form.Control.Feedback type="invalid">
                          {errors.selectionTypeId}
                        </Form.Control.Feedback>
                        <label htmlFor="selectionTypeId">{t("CONFIG.FILTER")}</label>
                      </Form.Floating>
                    </Form.Group>
                  </Col>                  
                </Row>

                <Row>
                  {values.selectionTypeId && values.selectionTypeId != '0' &&
                  <div>
                  <h5>{t(returnSubTitle(values.selectionTypeId))}</h5>
                  {values.selectionTypeId != '1' && <Form.Check
                    type="checkbox"
                    label={t('SELECT_ALL')}
                    onChange={(event) => {
                      selectAll(event.target.checked, values.listValues);
                    }}
                    checked={allSelected(values.listValues)}
                  />}
                  <br />
                  </div>
                  }
                    <Form.Group>
                      <Form.Floating>                        
                        <div style={{width: '80%', display: 'flex', flexWrap: 'wrap', justifyContent: 'flex-start', boxSizing: 'border-box', flexDirection: 'row'}}>
                        {values.listValues.map((l:ConfigImpositionModel) => {   
                          return (
                            <div key={l.id} style={{width: '33%', boxSizing: 'border-box'}}>                         
                            <Form.Check
                            type="checkbox"
                            id={l.id.toString()}
                            label={values.selectionTypeId == '2' ? t('PROFILE.'+l.name.toUpperCase()) : values.selectionTypeId == '1' ? t(l.name) : l.name}
                            checked={selectedList.includes(l.id)}
                            onChange={(event) => {
                              if (event.target.checked)
                                setSelectedList([...selectedList, l.id]);
                              else
                                setSelectedList(selectedList.filter(x => x != l.id));
                            }}
                            />
                            </div>)
                        })}
                        </div>
                      </Form.Floating>
                    </Form.Group>
                </Row>

              </Col>
            </Row>
          </Form>
        )}
      </Formik>
    </>
  );
};

export default PickupImpositionConfig;